import React, { PropTypes } from 'react';
import { FlatButton } from 'material-ui';

const StepperActions = ({ backButtonFunc, showBackButton, style, rightButtons }) => {
  const backButton = (
    <FlatButton
      label="back"
      secondary
      hoverColor="none"
      labelStyle={{ fontWeight: '600', left: '-20px' }}
      onTouchTap={backButtonFunc}
    />
  );
  const leftButton = showBackButton ? backButton : undefined;
  const outerContainerStyle = Object.assign({}, { width: '100%', flexDirection: 'row-reverse' }, style);
  return (
    <div style={outerContainerStyle} className="flex-center">
      <div style={{ float: 'right' }}>
        {rightButtons}
      </div>
      <div style={{ float: 'left' }}>
        {leftButton}
      </div>
    </div>
  );
};

StepperActions.propTypes = {
  backButtonFunc: PropTypes.func,
  showBackButton: PropTypes.bool,
  rightButtons: PropTypes.node,
  style: PropTypes.object,
};

export default StepperActions;



// WEBPACK FOOTER //
// ./src/app/components/contracting/generic-components/stepper-actions.jsx